const initialState = {
  estado: null,
  pesoNetoOrigen: 0,
  pesoNetoDescargado: 0
}

export default (state = initialState, action) => {
  switch (action.type) {
    case 'CTG_SIN_CONFIRMACION_TOTALES':
      return {
        ...state,
        estado: action.estado || null,
        pesoNetoOrigen: action.pesoNetoOrigen,
        pesoNetoDescargado: action.pesoNetoDescargado
      }
    default:
      return state
  }
}
